module.exports = "/images/mastercard.svg?3f1f8c5e527cd0b57b1ca1218bd05ae9";